import { createAsyncThunk } from '@reduxjs/toolkit';

import confirmAndClearOtherSelectionLayer from '../../../helpers/confirmAndClearOtherSelectionLayer';
import confirmAndClearOtherProductSelectionSource from '../../../helpers/confirmAndClearOtherProductSelectionSource';
import {
  selectProductSelection,
  selectProductSelectionCount,
  selectProductSelectionFeedback,
  selectIsBulkMediaView,
} from '../../selectors/productSelectionSelectors';

export default function createTreeSelectionThunk(actionType, commitAction) {
  return createAsyncThunk(
    actionType,
    async ({ anchorNodeId, ...commitPayload }, { dispatch, getState, rejectWithValue }) => {
      const canProceed = await confirmAndClearOtherSelectionLayer({
        dispatch,
        getState,
        targetLayer: 'products',
      });
      if (!canProceed) {
        return rejectWithValue({ cancelled: true });
      }

      const canSwitchSource = await confirmAndClearOtherProductSelectionSource({
        dispatch,
        getState,
        targetSource: 'tree',
      });
      if (!canSwitchSource) {
        return rejectWithValue({ cancelled: true });
      }

      dispatch(commitAction({
        ...commitPayload,
        keepChannelSelection: selectIsBulkMediaView(getState()),
      }));

      const state = getState();
      const feedback = selectProductSelectionFeedback(state);
      if (feedback) {
        return rejectWithValue(feedback);
      }

      const nextState = getState();
      return {
        anchorNodeId,
        selection: selectProductSelection(nextState),
        selectionCount: selectProductSelectionCount(nextState),
      };
    },
  );
}
